import React from 'react'
import { Contexts, Types } from '../types'
import _ from 'lodash'
import { useDebug, useEventBus } from '../hooks'
import { Helpers } from '../utils'
import Api from '../api'

const initialState: any = {
    // config, translations, data 
    items: {},
    itemsCount: 0,
    itemSubtotal: 0,

    updating: false,
    opened: false,
}

// removeCartItem: (cartItemID: string) => {},
// updateCartItem: (cartItemID: string, newQuantity: number) => {},
// cartItems: [], 
// cartItemsSubtotal: 0, 
// cartItemsCount: 0,

// isMinicartOpened: false,

// translations: {},
// links: {},

// TODO: Base Product provider and child providers for diff product types
// SingleProductContext
// VariableProductContext
// BundledProductContext

export const MinicartContext = React.createContext<any>({})

const MinicartProvider: React.FC<any> = ({ children, loading, config, theme, translations, data }) => { 
    
    console.log('minicproiv', data);
    
    useDebug(`MinicartProvider`)

    const [store, updateStore] = React.useState<any>({ ...initialState });

    const eventBus = useEventBus();

    const setState = React.useCallback((key: string, value: any) => {
        if (!(key in initialState)) throw Error(`Key ${key} is not valid state.`);
        updateStore((prevStore: any) => ({ ...prevStore, [key]: value instanceof Function ? value(prevStore[key]) : value, }))
    }, [])

    // Toggles any boolean state
    const toggleState = (key: string, force?: boolean) => {

        if (!(key in initialState)) throw Error(`Key ${key} is not a valid state.`);
        if (typeof initialState[key] !== 'boolean') throw Error(`Key ${key} is not a valid bool state.`);

        setState(key, (prevState: any) => _.isBoolean(force) ? force : !prevState);

    }

    React.useEffect(() => {
        if ( loading || _.isEmpty(data?.items) ) return;
        console.log(store.items, data.items);
        
        setState('items', Object.fromEntries(Object.entries(data?.items).map(([cartItemID, item]: any) => {
            
            if ( _.isEmpty(item?.bundledBy) ) {
                item.price = item?.price?.sale || item.price?.regular || 0;
                const priceArgs = {
                    displayMode: _.isBoolean(item.taxable) ? (item.taxable ? 'include' : 'exclude') : null ?? config.general.tax.displayMode,
                    taxClass: ! _.isEmpty(item?.taxClass) ? item.taxClass : config.general.tax.default,
                    taxRates: config.general.tax.rates,
                    precision: Math.abs(config.general.roundingPrecision),
                    price: item.price
                } 
                
                item.pricePerUnit = Helpers.getPrice({...priceArgs, quantity: 1});
                item.subtotal = Helpers.getPrice({...priceArgs, quantity: item.quantity.selected});
            } else {
                item.subtotal = 0;
            }

            return [cartItemID, item];

        })))
    }, [loading, data])

    const itemsCount = React.useMemo(() => Object.values(store.items).reduce((quantity: any, item: any) => quantity + (_.isEmpty(item?.bundledBy) ? item.quantity.selected : 0), 0), [store]);
    const itemsSubtotal = React.useMemo(() => Object.values(store.items).reduce((subtotal: any, item: any) => subtotal + (_.isEmpty(item?.bundledBy) ? item.subtotal : 0), 0), [store]);

    // const getCartItemsCount = (items: any) => Object.keys(items).length
    // const getItemsSubtotal = (items: any) => Object.values(items).map((item) => {
    //     return item.subtotal
    // })

    // const cartItemsCount = React.useMemo(() => {

    // }, []);

    // Always override the subtotal state when it gets updated from API
    // NOTE: Expecting it to be in provided in expected tax class 

    // Helpers
    const debouncedHandleUpdateCartItem = async ({ name, value, cartItemID }: { name: string, value: any, cartItemID: string }) => {

        setState('updating', true);
        const response: any = await Api.updateCartItem(cartItemID, {[name]: value});
        
        //const { items, subtotal } = response.data.data;
        
        if ( response.data && 'items' in response?.data && 'subtotal' in response?.data ) {
            //setCartItems(items);
            //setCartSubtotal(subtotal);
        }
        
        setState('updating', false);
        //return response;

    };


    const ajaxHandleUpdateCartItem = React.useMemo(
        () => _.debounce(debouncedHandleUpdateCartItem, 300)
    , []);


    const handleItemUpdate = ({ name, value, cartItemID }: { name: string, value: any, cartItemID: string }) => {
        console.log(cartItemID, name, value);

        if ( loading || store.updating ) return;
        if (!(cartItemID in store.items)) throw Error(`Update: Cart item #${cartItemID} is not longer contained in cart.`);
        if (!(name in store.items[cartItemID])) throw Error(`Update: Cart item #${cartItemID} does not contain field ${name}.`);
        if ( ! _.isEmpty(store.items[cartItemID]?.bundledBy) ) return;
        if (_.isEqual(store.items[cartItemID][name], value)) return;

        setState('items', (prevState: any) => {
            
            if (name === 'quantity') {

                if ( _.isEmpty(prevState[cartItemID]?.bundledBy) ) {
                    prevState[cartItemID][name].selected = value;
    
                    const priceArgs = {
                        displayMode: prevState[cartItemID].displayMode ?? config.general.tax.displayMode,
                        taxClass: ! _.isEmpty(prevState[cartItemID]?.taxClass) ? prevState[cartItemID].taxClass : config.general.tax.default,
                        taxRates: config.general.tax.rates,
                        precision: Math.abs(config.general.roundingPrecision),
                        quantity: prevState[cartItemID].quantity.selected,
                        price: prevState[cartItemID].price
                    }
    
                    prevState[cartItemID]['subtotal'] = Helpers.getPrice(priceArgs);
                } else {
                    prevState[cartItemID]['subtotal'] = 0;
                }    

            }

            return prevState;
        })

        ajaxHandleUpdateCartItem({name, value, cartItemID});

    } 

    const handleItemRemove = ({ cartItemID }: { cartItemID: string }) => {

        if ( loading || store.updating ) return;
        if (!(cartItemID in store.items)) throw Error(`Remove: Cart item #${cartItemID} is not longer contained in cart.`);
        if ( ! _.isEmpty(store.items[cartItemID]?.bundledBy) ) return;

        setState('items', (prevState: any) => {
            const newState: any = { ...prevState };
            delete newState[cartItemID];
            if ( ! _.isEmpty (prevState[cartItemID]['bundledItems'] ) ) {
                prevState[cartItemID]['bundledItems'].forEach((itemCartID: string) => delete newState[itemCartID])
            }
            return newState;
        })

        debouncedRemoveItem({cartItemID});
    }

    // Helpers
    const debouncedRemoveItem = async ({cartItemID }: {  cartItemID: string }) => {

        setState('updating', true);
        const response: any = await Api.removeCartItem(cartItemID);
        
        //const { items, subtotal } = response.data.data;
        
        if ( response.data && 'items' in response?.data && 'subtotal' in response?.data ) {
            //setCartItems(items);
            //setCartSubtotal(subtotal);
        }
        
        setState('updating', false);
        //return response;

    };

    React.useEffect(() => {

        eventBus.on('cartContentsUpdated', (props: any) => {   
            if ( _.isEmpty(props?.errors) ) {
                setTimeout(() => {
                    requestAnimationFrame(() => {
                        setState('opened', true);
                    })
                }, 50)
            }
        });

        return () => eventBus.remove('cartContentsUpdated');

    }, []);

    return (
        <MinicartContext.Provider
            value={{
                ...store,
                itemsCount,
                itemsSubtotal,
                config,
                theme,
                translations,
                loading,
                setState,
                toggleState,
                handleItemUpdate,
                handleItemRemove
            }}
            children={!_.isEmpty(data) ? children : null}
        />
    )
}

export default MinicartProvider;